'use client'

import { useEffect } from 'react'

interface ForceThemeProps {
  theme: 'light' | 'dark'
}

export default function ForceTheme({ theme }: ForceThemeProps) {
  useEffect(() => {
    const html = document.documentElement
    const previousTheme = html.getAttribute('data-theme')

    // Set the forced theme
    html.setAttribute('data-theme', theme)

    // Cleanup: restore previous theme when component unmounts
    return () => {
      if (previousTheme) {
        html.setAttribute('data-theme', previousTheme)
      }
    }
  }, [theme])

  return null
}
